import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {DrawerTitleComponent} from './drawer-title/drawer-title.component';
import {DrawerCardComponent} from './drawer-card/drawer-card.component';
import {DrawerCardTitleComponent} from './drawer-card-title/drawer-card-title.component';
import {DrawerLeftIconComponent} from './drawer-left-icon/drawer-left-icon.component';
import {DrawerBackButtonComponent} from './drawer-back-button/drawer-back-button.component';
import {DrawerComponent} from './drawer.component';
import {ToastContainerDirective, ToastrModule} from 'ngx-toastr';
import {DrawerToastrComponent} from './drawer-toastr/drawer-toastr.component';
import {SharedModule} from '../../../modules/shared/shared.module';
import {A11yModule} from '@angular/cdk/a11y';
import {DrawerBackLinkComponent} from '../../dumb/drawer-back-link/drawer-back-link.component';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [
    DrawerComponent,
    DrawerTitleComponent,
    DrawerCardComponent,
    DrawerCardTitleComponent,
    DrawerLeftIconComponent,
    DrawerBackButtonComponent,
    DrawerToastrComponent,
    DrawerBackLinkComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    A11yModule,
    ToastrModule,
    ToastContainerDirective,
    SharedModule,
    RouterModule,
  ],
  exports: [
    DrawerComponent,
    DrawerTitleComponent,
    DrawerCardComponent,
    DrawerCardTitleComponent,
    DrawerLeftIconComponent,
    DrawerBackButtonComponent,
    DrawerToastrComponent,
    DrawerBackLinkComponent,
  ],
})
export class DrawerModule {}
